export const MILAN_SITE_START = 'https://milanlaser';
export const CORPORATE_SITE = MILAN_SITE_START + '.com';
export const GATSBY_DOMAIN = MILAN_SITE_START + 'gatsby.com';
export const DOWNLOAD_PATH = 'https://download.milanlaser.com';
export const MILAN_PHONE = '833-667-2967';
export const NO_RAZOR = '1-833-NO-RAZOR';

// export const GOOGLE_REVIEWS_URL_START = 'https://www.google.com/search?q=milan+laser+hair+removal+'
export const YELP_URL_START = 'https://www.yelp.com/biz/milan-laser-hair-removal-';
export const FACEBOOK_URL_START = 'https://www.facebook.com/MilanLaser';
export const WEB_TO_LEAD_LINK = 'deprecated';

export const FIREBASE_STORAGE_PATH = `https://firebasestorage.googleapis.com/v0/b/milan-stores-ea6e2.appspot.com/o/`;

export const PLANS_START_AT = '45';
export const WAXING_COST_MONTH = 29;
export const WAXING_COST_YEAR = 23;
export const TREATMENTS_COUNT_MONTH = 90;

// Build-time counts for server-rendered and static contexts (e.g. /ai-information), where the live
// figures from useMetrics can't be used: those are derived client-side from Firebase and render as 0
// in the server-rendered HTML that crawlers and AI agents actually read. These constants are the
// shared source of truth so the numbers can't drift between pages; keep them in step with the live
// metrics. CLINIC_COUNT mirrors useMetrics' rounding (nearest 10) and is displayed with a trailing
// "+". Note: static/llms.txt can't import this and must be synced by hand.
export const CLINIC_COUNT = 410;
export const STATE_COUNT = 38;

export const PULSES_PER_DAY = 50;
export const BRAZILIAN_WAX_COST_LIFETIME = 15;
export const BIKINI_WAX_COST_LIFETIME = 11;

export const BREAKPOINTS = {
    xxs: 0,
    xs: 320,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};

export const NETLIFY_FUNCTIONS_PATH = '/.netlify/functions/';

export const FEBRUARY_DISCOUNT_PERCENTAGE = 70;

// Forms that replaced the SMS opt-in checkbox with MarketingConsentMsg (WEBDEV-4145/4146/4150/4493) treat
// clicking the CTA as the opt-in. Derive marketing_sms_optout / sms_optin / smsOptIn from this so the
// consent rule lives in one place.
export const CTA_CLICK_SMS_OPT_IN = true;
